import {
  GET_SUBSCRIBER,
  GET_SUBSCHOICE,
  EDIT_SUBSCRIPTIONS_REQUEST,
  EDIT_SUBSCRIPTIONS_SUCCESS,
  EDIT_SUBSCRIPTIONS_FAIL,
  GET_SUBSCRIPTION_CHECKBOX
} from "../constants/subscription";

const initialState = {
  allSubscribers: null,
  subsChoice : null,
  loading: false,
  error: null,
  success: false,
  savedSubscriptions: [], 
}

export default function subscriptions( state = initialState, action ){
  switch(action.type){

    case GET_SUBSCRIBER:
      return { ...state, allSubscribers: action.data}

      case GET_SUBSCHOICE:
      return { ...state, subsChoice: action.data}

        case EDIT_SUBSCRIPTIONS_REQUEST:
      return { ...state, loading: true, success: false };

    case EDIT_SUBSCRIPTIONS_SUCCESS:
      return { ...state, loading: false, success: true };

    case EDIT_SUBSCRIPTIONS_FAIL:
      return { ...state, loading: false, error: action.payload, success: false };
    case GET_SUBSCRIPTION_CHECKBOX:
      return {...state, savedSubscriptions: action.data};  

    default:
      return state;
  }
}